module.exports = __webpack_public_path__ + "static/media/bg.77891c6b.png";